// 定义一些公共的属性和方法
const syOssUrl = 'https://alioss.sanyue100.com'
// const syOssUrl = 'http://192.168.6.132:8081'
// 暴露出这些属性
export default {
    syOssUrl,
}
